import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { TotaraAuthService } from '../../totara/services/totara-auth.service';
import { CmsAuthService } from '../../cms/services/cms-auth.service';
import { AuthTarget } from '../models/auth-target.model';

// IMPORTANT We never should use canActivate.next(false) when we redirect to idp page (for this case we have problem with auth-totara|auth)
// when we are on /auth-totara|auth?authSessionId="value" and we will set canActivate=false then auth-totara|auth component will be created again
// and all actions will be called again. On auth-totara|auth component we have login action and then we get 401
// because login will be called with the same authSessionParam which has already been used up
export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const totaraAuthService = inject(TotaraAuthService);
  const cmsAuthService = inject(CmsAuthService);
  const canActivate: ReplaySubject<boolean> = new ReplaySubject<boolean>();
  const isTotaraAuth: boolean = totaraAuthService.isAuth;
  const isCmsAuth: boolean = cmsAuthService.isAuth;

  if (!isTotaraAuth) {
    const url = state?.url;
    authService.refreshSession(url, AuthTarget.totara);
  }

  if (isTotaraAuth && !isCmsAuth) {
    const url = state?.url;
    authService.refreshSession(url, AuthTarget.cms);
  }

  if (isTotaraAuth && isCmsAuth) {
    canActivate.next(true);
  }

  return canActivate.asObservable();
};
